/* Oùmami : fiche produit (section oum-produit).
   - Cartes de variantes et options d'achat : prix, prix unitaires, remise et bouton changent sur place, à partir des
     données JSON de la section ; l'adresse prend ?variant= comme sur le site Instant.
   - Ajout au panier : formulaire produit natif envoyé par oum.ajouterAuPanier (tiroir du pied de page).
   - Galerie : vignettes reliées au carrousel principal (la visionneuse plein écran est dans oum-visionneuse.js).
   Tout passe par la délégation d'événements : une section rechargée dans l'éditeur fonctionne sans réinitialisation. */
(() => {
  const oum = (window.oum = window.oum || {});
  if (oum.produitCharge) return;
  oum.produitCharge = true;

  const donnees = (racine) => {
    if (!racine._donnees) {
      const s = racine.parentElement.querySelector('script[id^="oum-donnees-"]');
      racine._donnees = s ? JSON.parse(s.textContent) : {};
    }
    return racine._donnees;
  };

  /* Montant en centimes au format de la boutique (shop.money_format), pour le prix du bouton multiplié par la quantité */
  const SEPARATEURS = {
    amount: [',', '.', 2],
    amount_no_decimals: [',', '.', 0],
    amount_with_comma_separator: ['.', ',', 2],
    amount_no_decimals_with_comma_separator: ['.', ',', 0],
    amount_with_space_separator: [' ', ',', 2],
    amount_with_period_and_space_separator: [' ', '.', 2],
    amount_with_apostrophe_separator: ["'", '.', 2],
  };
  const argent = (centimes, format) =>
    format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, cle) => {
      const [milliers, decimale, chiffres] = SEPARATEURS[cle] || SEPARATEURS.amount;
      const [entier, reste] = (centimes / 100).toFixed(chiffres).split('.');
      return entier.replace(/\B(?=(\d{3})+(?!\d))/g, milliers) + (reste ? decimale + reste : '');
    });

  function etat(racine) {
    const formulaire = racine.querySelector('[data-oum-formulaire]');
    const id = formulaire.querySelector('[data-oum-variante-id]').value;
    const menu = racine.querySelector('[data-oum-plan]');
    return {
      formulaire,
      variante: donnees(racine)[id],
      id,
      abonnement: racine.dataset.mode === 'abonnement',
      plan: menu ? menu.value : '',
    };
  }

  function rafraichir(racine) {
    const e = etat(racine);
    if (!e.variante) return;
    const plan = e.variante.plans[e.plan];
    const optionAbo = racine.querySelector('[data-oum-option-abo]');

    // Une variante sans plan (ex. « 1 bouillon ») ne peut pas être prise en abonnement
    if (optionAbo) optionAbo.hidden = !plan;
    if (!plan && e.abonnement) {
      const unique = racine.querySelector('[data-oum-mode][value="unique"]');
      if (unique) unique.checked = true;
      racine.dataset.mode = 'unique';
      e.abonnement = false;
    }

    const champPlan = e.formulaire.querySelector('[data-oum-plan-id]');
    champPlan.value = e.abonnement && plan ? e.plan : '';
    champPlan.disabled = !(e.abonnement && plan);

    const prixUnique = racine.querySelector('[data-oum-prix-unique]');
    if (prixUnique) prixUnique.textContent = e.variante.prix;
    const prixPlan = racine.querySelector('[data-oum-prix-plan]');
    if (prixPlan && plan) prixPlan.textContent = plan.prix;
    const remise = racine.querySelector('[data-oum-remise]');
    if (remise) {
      remise.hidden = !plan || plan.remise <= 0;
      if (plan) remise.querySelector('[data-oum-remise-valeur]').textContent = `${plan.remise}%`;
    }
    racine.querySelectorAll('[data-oum-prix-abo]').forEach((el) => {
      const v = donnees(racine)[el.dataset.oumPrixAbo];
      const p = v && v.plans[e.plan];
      if (p) el.textContent = p.prix;
    });
    const valeur = racine.querySelector('[data-oum-selecteur-valeur]');
    const liste = racine.querySelector('select[data-oum-choix-variante]');
    if (valeur && liste && liste.selectedOptions[0]) valeur.textContent = liste.selectedOptions[0].textContent;
    const nomPlan = racine.querySelector('[data-oum-plan-nom]');
    const menu = racine.querySelector('[data-oum-plan]');
    if (nomPlan && menu && menu.selectedOptions[0]) nomPlan.textContent = menu.selectedOptions[0].textContent;

    const rupture = racine.querySelector('[data-oum-rupture]');
    if (rupture) rupture.hidden = e.variante.disponible;
    const bouton = racine.querySelector('[data-oum-ajouter]');
    if (bouton) {
      const champ = racine.querySelector('[data-oum-quantite]');
      const quantite = champ ? Math.max(1, parseInt(champ.value, 10) || 1) : 1;
      const centimes = (e.abonnement && plan ? plan.centimes : e.variante.centimes) * quantite;
      const prix = argent(centimes, donnees(racine).format);
      bouton.disabled = !e.variante.disponible;
      bouton.classList.toggle('oum-produit__bouton--indisponible', !e.variante.disponible);
      bouton.querySelector('[data-oum-bouton-texte]').textContent = e.variante.disponible
        ? `${bouton.dataset.libelle} ${prix}`
        : bouton.dataset.libelleRupture;
    }
    const erreur = racine.querySelector('[data-oum-erreur]');
    if (erreur) erreur.hidden = true;
  }

  document.addEventListener('change', (ev) => {
    const racine = ev.target.closest('[data-oum-produit]');
    if (!racine) return;
    if (ev.target.matches('[data-oum-choix-variante]')) {
      racine.querySelector('[data-oum-variante-id]').value = ev.target.value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', ev.target.value);
      history.replaceState(history.state, '', url);
    } else if (ev.target.matches('[data-oum-mode]')) {
      racine.dataset.mode = ev.target.value;
    } else if (!ev.target.matches('[data-oum-plan]')) {
      return;
    }
    rafraichir(racine);
  });

  document.addEventListener('submit', async (ev) => {
    const formulaire = ev.target.closest('[data-oum-formulaire]');
    if (!formulaire || !oum.ajouterAuPanier) return;
    ev.preventDefault();
    const racine = formulaire.closest('[data-oum-produit]');
    const bouton = racine.querySelector('[data-oum-ajouter]');
    const erreur = racine.querySelector('[data-oum-erreur]');
    if (bouton.getAttribute('aria-busy') === 'true') return;
    bouton.setAttribute('aria-busy', 'true');
    if (erreur) erreur.hidden = true;
    try {
      await oum.ajouterAuPanier(new FormData(formulaire));
    } catch (e) {
      if (erreur) {
        erreur.textContent = (e && (e.description || e.message)) || erreur.dataset.defaut || '';
        erreur.hidden = !erreur.textContent;
      }
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  });

  /* Quantité : boutons − / + (1 à 999), le champ appartient au formulaire produit (attribut form) */
  document.addEventListener('click', (ev) => {
    const b = ev.target.closest('[data-oum-quantite-pas]');
    if (!b) return;
    const champ = b.parentElement.querySelector('[data-oum-quantite]');
    const v = (parseInt(champ.value, 10) || 1) + Number(b.dataset.oumQuantitePas);
    champ.value = Math.min(Number(champ.max) || 999, Math.max(Number(champ.min) || 1, v));
    rafraichir(b.closest('[data-oum-produit]'));
  });
  document.addEventListener('input', (ev) => {
    if (ev.target.matches('[data-oum-quantite]')) rafraichir(ev.target.closest('[data-oum-produit]'));
  });

  /* ---------- Galerie ---------- */
  const carrousel = (racine, selecteur) => {
    const c = racine.querySelector(selecteur);
    return c && c.swiper;
  };

  function marquerVignette(racine, index) {
    racine.querySelectorAll('[data-oum-vignette]').forEach((v) => {
      const actif = Number(v.dataset.oumVignette) === index;
      v.classList.toggle('oum-galerie__vignette--active', actif);
      v.setAttribute('aria-current', actif ? 'true' : 'false');
    });
  }

  document.addEventListener('oum:carrousel-pret', (ev) => {
    if (!ev.target.matches('[data-oum-galerie]')) return;
    const racine = ev.target.closest('[data-oum-produit]');
    ev.target.swiper.on('slideChange', (s) => marquerVignette(racine, s.activeIndex));
  });

  document.addEventListener('click', (ev) => {
    const vignette = ev.target.closest('[data-oum-vignette]');
    if (!vignette) return;
    const racine = vignette.closest('[data-oum-produit]');
    const s = carrousel(racine, '[data-oum-galerie]');
    const index = Number(vignette.dataset.oumVignette);
    if (s) s.slideTo(index);
    marquerVignette(racine, index);
  });
})();
